import React from 'react';
import { useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import GeneralCalendarForForm from 'utils/calendar/GeneralCalendarForForm';
import { nvl } from 'utils/nvl';

const Popup = ({ module, moduleGroups, moduleType, setModuleType, confirmModule, user }) => {
  const { register, handleSubmit, errors } = useForm();
  const auths = useSelector((store) => store.auths.auth);

  return (
    <form onSubmit={handleSubmit(confirmModule)}>
      <div>
        <p>고유번호</p>
        <input type="text" name="modelNo" ref={register({ required: true, maxLength: 20 })} defaultValue={module.modelNo} />
      </div>
      <ErrorMessage errors={errors} name="modelNo" message="고유번호를 입력해주세요" />
      {/* <div>
        <p>장치그룹</p>
        <select
          name="moduleGroupIdx"
          ref={register({ required: true })}
          defaultValue={module.moduleGroup !== null && module.moduleGroup.moduleGroupIdx}
        >
          {moduleGroups.map((moduleGroup) => {
            return <option value={moduleGroup.moduleGroupIdx}>{moduleGroup.modelNm}</option>;
          })}
        </select>
      </div> */}
      <div>
        <p>장치명</p>
        <input type="text" name="modelNm" ref={register({ required: true, maxLength: 20 })} defaultValue={module.modelNm} />
      </div>
      <ErrorMessage errors={errors} name="modelNm" message="장치명을 입력해주세요" />
      <div>
        <p>교정 유효기간</p>
        <GeneralCalendarForForm date={module.deadline} name="deadline" position={{ right: '-115', bottom: '0' }} register={register} />
      </div>
      <div>
        <p>검지유형</p>
        <select name="moduleScn" ref={register({ validate: (value) => value !== '-1' })} defaultValue={module.moduleScn}>
          <option value="-1">검지유형</option>
          <option value="0">온습도</option>
        </select>
      </div>
      <ErrorMessage errors={errors} name="moduleScn" message="올바른 검지유형을 선택해주세요" />
      <div>
        <p>운용유형</p>
        <select
          name="moduleType"
          ref={register({ validate: (value) => value !== '0' })}
          defaultValue={module.moduleType}
          onChange={({ target: { value } }) => {
            setModuleType(value);
          }}
        >
          <option value="0">운용유형</option>
          <option value="IT">휴대형</option>
        </select>
      </div>
      <ErrorMessage errors={errors} name="moduleType" message="올바른 운용유형을 선택해주세요" />
      <div>
        <p>관리감독자</p>
        <select name="authIdx" ref={register({ validate: (value) => value !== '0' })} defaultValue={module.authIdx}>
          <option value="0">담당정보</option>
          {auths
            .filter((d) => d.level === 4)
            .map((auth) => {
              return (
                <option key={auth.authIdx} value={auth.authIdx}>
                  {auth.authNm}
                </option>
              );
            })}
        </select>
      </div>
      <ErrorMessage errors={errors} name="authIdx" message="올바른 관리감독자를 선택해주세요" />
      <div>
        <p>설비번호</p>
        <input type="text" name="areaNo" ref={register} defaultValue={module.areaNo} disabled={moduleType === 'DT'} />
      </div>
      <div>
        <p>설비명</p>
        <input type="text" name="areaNm" ref={register} defaultValue={module.areaNm} disabled={moduleType === 'DT'} />
      </div>
      <button type="submit">{nvl(module.moduleIdx, null) === null ? '등록' : '수정'}</button>
    </form>
  );
};

export default Popup;
